module.exports = __webpack_public_path__ + "img/company.23a8c9b5.svg";